<template>
  <div :class="style['bottom-panel']" style="height: auto">
    <div :class="style['selection-item']">
      <div>{{ $t('adults') }}</div>
      <counter :count="adults" :decrease-count="decreaseAdults" :increase-count="increaseAdults" />
    </div>
    <div :class="style['selection-item']">
      <div>{{ $t('children') }}</div>
      <div>
        <counter
          :count="children"
          :decrease-count="decreaseChildren"
          :increase-count="increaseChildren"
        />
      </div>
    </div>
    <div v-if="childAgeShow" :class="[style['selection-item'], style['selection-item-sub']]">
      <div v-for="(age, index) in childAges" :class="style['sub-item']">
        <div>{{ $t('ageOfChild') }} {{ index + 1 }}</div>
        <div :class="style['select-container']">
          <select @change="changeChildAge($event, index)">
            <option
              v-for="childAgeOption in childAgeOptions"
              :value="childAgeOption"
              :selected="age === childAgeOption"
            >
              {{ childAgeOption }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <label :class="style['selection-item']">
      <span>{{ $t('smoking') }}</span>
      <checkbox :checked="smoking" :toggle-check="toggleSmoking" />
    </label>
    <div :class="style.controls">
      <button :class="style['vdp-button']" @click="closePanel">{{ $t('close') }}</button>
    </div>
  </div>
</template>

<script>
import Counter from 'UtilityComponents/Counter.vue'
import Checkbox from 'UtilityComponents/Checkbox.vue'
import style from '../scss/_bottompanel.scss'
import { useBottomPanelStore } from 'Store/bottom-panel'

export default {
  components: {
    Counter,
    Checkbox
  },

  setup() {
    const bottomPanelStore = useBottomPanelStore()

    return { bottomPanelStore }
  },

  data() {
    return { style }
  },
  computed: {
    adults() {
      return this.reservationFormStore.adults
    },
    children() {
      return this.reservationFormStore.children
    },
    smoking() {
      return this.reservationFormStore.smoking
    },
    childAges() {
      return this.reservationFormStore.childAges
    },
    childAgeShow() {
      return this.reservationFormStore.childAges.length !== 0
    },
    childAgeOptions() {
      const maxChildAge = this.bottomPanelStore.maxKidAge + 1
      return Array.apply(null, { length: maxChildAge }).map(Number.call, Number)
    }
  },
  methods: {
    toggleSmoking() {
      this.reservationFormStore.toggleReservationFormSmoking()
    },
    increaseAdults() {
      this.reservationFormStore.increaseReservationFormAdults()
    },
    decreaseAdults() {
      if (this.adults > 0) {
        this.reservationFormStore.decreaseReservationFormAdults()
      }
    },
    increaseChildren() {
      this.reservationFormStore.increaseReservationFormChildren()
    },
    decreaseChildren() {
      this.reservationFormStore.decreaseReservationFormChildren()
    },
    changeChildAge(e, index) {
      this.reservationFormStore.updateReservationFormChildAges({
        index,
        value: parseInt(e.target.value)
      })
    },
    closePanel() {
      this.bottomPanelStore.setBottomPanelComponent()
    }
  }
}
</script>
